import React from 'react'
import { BlueConicBoost } from '@pushly/models/lib/structs/journeys'
import { BlueConicConfigurationContext } from './context'
import { getRandId } from '@pushly/models/lib/utils/get-rand-id'
import { Filter } from '../filters/types'
import { ProductsFilters } from '../filters/enums'

export type BlueConicConfigurationDispatchPack =
    | { type: 'add-boost'; boost: BlueConicBoost }
    | { type: 'remove-boost'; boost: BlueConicBoost }
    | { type: 'update-boost'; boost: BlueConicBoost; change: BlueConicBoost }
    | { type: 'set-id'; id: string }
    | { type: 'set-filters'; filters: { included: any; excluded: any; products: any[] } }
    | { type: 'add-filter'; filterType: 'included' | 'excluded'; filter: Filter }
    | { type: 'remove-filter'; filterType: 'included' | 'excluded'; filterKey: string }
    | { type: 'remove-filter'; filterType: 'products'; filter: ProductsFilters }
    | { type: 'update-filter'; filterType: 'included' | 'excluded'; filterKey: string; filter: Filter }
    | { type: 'update-filter'; filterType: 'products'; filter: ProductsFilters }

export const blueConicConfigurationReducer = (
    context: BlueConicConfigurationContext,
    action: BlueConicConfigurationDispatchPack,
) => {
    const newContext = { ...context }

    switch (action.type) {
        case 'add-boost':
            newContext.boosts.push(action.boost)
            break
        case 'remove-boost':
            const removeIdx = newContext.boosts.findIndex((b) => b.algorithm === action.boost.algorithm)
            newContext.boosts.splice(removeIdx, 1)
            break
        case 'update-boost':
            const boostIdx = newContext.boosts.findIndex((b) => b.algorithm === action.boost.algorithm)
            newContext.boosts[boostIdx] = action.boost.clone(action.change)
            break
        case 'set-id':
            newContext.id = action.id
            break
        case 'set-filters':
            newContext.filters = action.filters
            break
        case 'add-filter':
            newContext.filters[action.filterType].set(getRandId(), action.filter)
            break
        case 'remove-filter':
            if (action.filterType === 'products') {
                const idx = newContext.filters.products.indexOf(action.filter)
                if (idx !== -1) {
                    newContext.filters.products.splice(idx, 1)
                }
            } else {
                newContext.filters[action.filterType].delete(action.filterKey)
            }
            break
        case 'update-filter':
            if (action.filterType === 'products') {
                const idx = newContext.filters.products.indexOf(action.filter)
                if (idx === -1) {
                    newContext.filters.products.push(action.filter)
                } else {
                    newContext.filters.products.splice(idx, 1, action.filter)
                }
            } else {
                newContext.filters[action.filterType].set(action.filterKey, action.filter)
            }
            break
        default:
            break
    }

    return newContext
}

export const BlueConicConfigurationDispatchContext = React.createContext<
    React.Dispatch<BlueConicConfigurationDispatchPack>
>(null!)
